'use strict';

const { callPlanHatPageActions } = require('../planHat/pageActions.js');

const setUpPlanHat = ($transitions, $location, pmtPlanHatService) => {
	$transitions.onSuccess({}, function (transition) {
		callPlanHatPageActions(pmtPlanHatService, $location, transition.to().name);
		pmtPlanHatService.trackNavigate($location.absUrl());
	});
};

module.exports = {
	setUpPlanHat
};
